import styled from "styled-components";

export const GridContainer = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
`;

export const DroppableAreaContainer = styled.div`
    position: relative;
    overflow: hidden;
    outline: none;
    cursor: pointer;
    * {
        pointer-events: none; // using pointer events so that we can detect mouse up in LibraryComponent
    }
`;

export const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const GridImage = styled.img`
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;

export const DropShadowWrapper = styled.div`
    position: absolute;
    user-select: none;
    pointer-events: auto;
    opacity: 1;
    width: 100%;
    height: 100%;
`;

export const GridImageChild = styled.div`
    width: 100%;
    height: 100%;
`;

export const GridDefaultImage = styled(GridImageChild)`
    background: ${(props) => `url("${props.assetUrl}/images/frames/bg-frame.png") 50% / auto 100%`};
`;

export const VIGNETTE = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 2;
    background-image: radial-gradient(
        circle farthest-side at center center,
        rgba(0, 0, 0, 0) 70%,
        rgba(0, 0, 0, var(--vignette)) 130%
    );
`;

export const Loader = styled.div`
    width: 100%;
    height: 100%;
    position: absolute; top: 0; left: 0;
    display: flex; align-items: center; justify-content: center;

    img {
        width: 100%;
        max-height: 48px;
        object-fit: contain;
    }
`


// WEBPACK FOOTER //
// ./src/components/Grid/styledComponent.js